import styled from 'styled-components'

export const Buttons = styled.div`
  &:not(:last-child) {
    margin-bottom: 1.875rem;
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: stretch;
  flex-basis: 100%;
  margin: auto;
  max-width: ${props => (props.full ? 'initial' : '18.75rem')};

  &:not(:last-child) {
    margin-bottom: 0.625rem;
  }
`
